import axios from "axios";
import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css";
import { Helmet } from 'react-helmet-async';
import React,{ useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft, Plus, X } from 'react-feather';
import Sidebar from './sidebar';
import { Link } from "react-router-dom";
import api from "../api";
import { fetchExchangeRates } from "../exchangeRateService";
import { checkStoreSetupStatus } from "./storeSetupUtils";

function AddProduct() {    
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl0 = process.env.REACT_APP_BASE_URL_IMG;
    const VendorId = localStorage.getItem('vendor_id');
    const navigate = useNavigate();
    const location = useLocation();
    const [setupStatus, setSetupStatus] = useState({
        subscription: false,
        payment: false,
        delivery: false,
        product: false,
    });
    const modules = {
        toolbar: [
            ['bold', 'italic', 'underline'],
            [{ 'list': 'ordered' }],
        ],
    };

    const formats = [
        'bold',
        'italic',
        'underline',
        'list'
    ];

    const { quill, quillRef } = useQuill({
        modules,
        formats,
        theme: "snow",
    });

    const [errorMsg, setErrorMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [CategoryData, setCategoryData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedCurrency, setSelectedCurrency] = useState("");
    const [ProductData, setProductData] = useState({
        "vendor": '',
        "category": '',
        "title": '',
        "slug": '',
        "detail": '',
        "offer_price": 0,
        "price": '',
        "usd_price": '',
        "keywords": '',
        "gender": 'Unisex',
        "image": '',
        "visits": '',
        "status": '',
        "currency":'',
    });
    const [ProductImgs, setProductImgs] = useState([]);
    const [inputFields, setInputFields] = useState([["", ""]]);
    const queryParams = new URLSearchParams(location.search);
    const templateId = queryParams.get("template_id");
    const [preloadedImages, setPreloadedImages] = useState([]);   // holds URLs

    
    const token = localStorage.getItem("access_token");

    // Reference to the div with id="image_preview1"
    const imagePreviewRef = useRef(null);
    const prevImgsRef = useRef(null);
    

    useEffect(() => {
        setProductData({
            ...ProductData,
            'vendor': VendorId
        });
        if (templateId) {
            loadTemplateProduct(templateId);
        }

        fetchData(baseUrl + '/categories/');
         // Retrieve customer data from localStorage when the component mounts
        const storedCurrency = localStorage.getItem('baseCurrency');
        if (storedCurrency === null) {
            // Fetch user's country and set default currency
            const fetchAndSetCurrency = async () => {
                try {
                    const res = await fetch("https://ipapi.co/json/");
                    const data = await res.json();
        
                    const countryCode = data.country_code;
                    const country = data.country_name;
                    const currency = getCurrencyByCountry(countryCode);
        
                    const currencyData = { currency, country };
                    localStorage.setItem("selectedCurrency", JSON.stringify(currencyData));
                    localStorage.setItem("baseCurrency", currency);
        
                    setSelectedCurrency(currency);
                    fetchExchangeRates(currency);
                } catch (error) {
                    // Optional: set a fallback currency or log the error
                    // console.error("Failed to fetch user location:", error);
                } finally {
                    setLoading(false);
                }
            };
    
            fetchAndSetCurrency();
        }
        const getCurrencyByCountry = (countryCode) => {
        const currencyMap = {
            AF: 'AFN', // Afghanistan
            AL: 'ALL', // Albania
            DZ: 'DZD', // Algeria
            AD: 'EUR', // Andorra
            AO: 'AOA', // Angola
            AR: 'ARS', // Argentina
            AM: 'AMD', // Armenia
            AU: 'AUD', // Australia
            AT: 'EUR', // Austria
            AZ: 'AZN', // Azerbaijan
            BH: 'BHD', // Bahrain
            BD: 'BDT', // Bangladesh
            BY: 'BYN', // Belarus
            BE: 'EUR', // Belgium
            BZ: 'BZD', // Belize
            BJ: 'XOF', // Benin
            BT: 'BTN', // Bhutan
            BO: 'BOB', // Bolivia
            BA: 'BAM', // Bosnia and Herzegovina
            BW: 'BWP', // Botswana
            BR: 'BRL', // Brazil
            BN: 'BND', // Brunei
            BG: 'BGN', // Bulgaria
            BF: 'XOF', // Burkina Faso
            BI: 'BIF', // Burundi
            KH: 'KHR', // Cambodia
            CM: 'XAF', // Cameroon
            CA: 'CAD', // Canada
            CV: 'CVE', // Cape Verde
            CL: 'CLP', // Chile
            CN: 'CNY', // China
            CO: 'COP', // Colombia
            KM: 'KMF', // Comoros
            CG: 'XAF', // Congo (Republic)
            CD: 'CDF', // Congo (DR)
            CR: 'CRC', // Costa Rica
            HR: 'HRK', // Croatia
            CU: 'CUP', // Cuba
            CY: 'EUR', // Cyprus
            CZ: 'CZK', // Czech Republic
            DK: 'DKK', // Denmark
            DJ: 'DJF', // Djibouti
            DO: 'DOP', // Dominican Republic
            EG: 'EGP', // Egypt
            SV: 'SVC', // El Salvador
            EE: 'EUR', // Estonia
            ET: 'ETB', // Ethiopia
            FI: 'EUR', // Finland
            FR: 'EUR', // France
            GA: 'XAF', // Gabon
            GM: 'GMD', // Gambia
            GE: 'GEL', // Georgia
            DE: 'EUR', // Germany
            GH: 'GHS', // Ghana
            GR: 'EUR', // Greece
            GT: 'GTQ', // Guatemala
            GN: 'GNF', // Guinea
            GW: 'XOF', // Guinea-Bissau
            GY: 'GYD', // Guyana
            HT: 'HTG', // Haiti
            HN: 'HNL', // Honduras
            HK: 'HKD', // Hong Kong
            HU: 'HUF', // Hungary
            IS: 'ISK', // Iceland
            IN: 'INR', // India
            ID: 'IDR', // Indonesia
            IR: 'IRR', // Iran
            IQ: 'IQD', // Iraq
            IE: 'EUR', // Ireland
            IL: 'ILS', // Israel
            IT: 'EUR', // Italy
            JM: 'JMD', // Jamaica
            JP: 'JPY', // Japan
            JO: 'JOD', // Jordan
            KZ: 'KZT', // Kazakhstan
            KE: 'KES', // Kenya
            KW: 'KWD', // Kuwait
            KG: 'KGS', // Kyrgyzstan
            LA: 'LAK', // Laos
            LV: 'EUR', // Latvia
            LB: 'LBP', // Lebanon
            LS: 'LSL', // Lesotho
            LR: 'LRD', // Liberia
            LY: 'LYD', // Libya
            LT: 'EUR', // Lithuania
            LU: 'EUR', // Luxembourg
            MG: 'MGA', // Madagascar
            MW: 'MWK', // Malawi
            MY: 'MYR', // Malaysia
            MV: 'MVR', // Maldives
            ML: 'XOF', // Mali
            MT: 'EUR', // Malta
            MX: 'MXN', // Mexico
            MD: 'MDL', // Moldova
            MN: 'MNT', // Mongolia
            MA: 'MAD', // Morocco
            MZ: 'MZN', // Mozambique
            MM: 'MMK', // Myanmar
            NA: 'NAD', // Namibia
            NP: 'NPR', // Nepal
            NL: 'EUR', // Netherlands
            NZ: 'NZD', // New Zealand
            NI: 'NIO', // Nicaragua
            NE: 'XOF', // Niger
            NG: 'NGN', // Nigeria
            NO: 'NOK', // Norway
            OM: 'OMR', // Oman
            PK: 'PKR', // Pakistan
            PG: 'PGK', // Papua New Guinea
            PY: 'PYG', // Paraguay
            PE: 'PEN', // Peru
            PH: 'PHP', // Philippines
            PL: 'PLN', // Poland
            PT: 'EUR', // Portugal
            QA: 'QAR', // Qatar
            RO: 'RON', // Romania
            RU: 'RUB', // Russia
            RW: 'RWF', // Rwanda
            SA: 'SAR', // Saudi Arabia
            SN: 'XOF', // Senegal
            RS: 'RSD', // Serbia
            SC: 'SCR', // Seychelles
            SL: 'SLL', // Sierra Leone
            SG: 'SGD', // Singapore
            SK: 'EUR', // Slovakia
            SI: 'EUR', // Slovenia
            ZA: 'ZAR', // South Africa
            ES: 'EUR', // Spain
            LK: 'LKR', // Sri Lanka
            SD: 'SDG', // Sudan
            SR: 'SRD', // Suriname
            SZ: 'SZL', // Eswatini
            SE: 'SEK', // Sweden
            CH: 'CHF', // Switzerland
            SY: 'SYP', // Syria
            TW: 'TWD', // Taiwan
            TZ: 'TZS', // Tanzania
            TH: 'THB', // Thailand
            TG: 'XOF', // Togo
            TO: 'TOP', // Tonga
            TN: 'TND', // Tunisia
            TR: 'TRY', // Turkey
            UG: 'UGX', // Uganda
            UA: 'UAH', // Ukraine
            AE: 'AED', // United Arab Emirates
            GB: 'GBP', // United Kingdom
            US: 'USD', // United States
            UY: 'UYU', // Uruguay
            UZ: 'UZS', // Uzbekistan
            VE: 'VES', // Venezuela
            VN: 'VND', // Vietnam
            YE: 'YER', // Yemen
            ZM: 'ZMW', // Zambia
            ZW: 'ZWL'  // Zimbabwe
            };
        ;
        return currencyMap[countryCode] || 'KES'; // Default to USD if country not found
        };
    }, []);

    useEffect(() => {
        if (!quill) return;

        // Load template description AFTER quill initializes
        if (ProductData.detail) {
            quill.root.innerHTML = ProductData.detail;
        }

        quill.on("text-change", () => {
            setProductData(prev => ({
                ...prev,
                detail: quill.root.innerHTML,
            }));
        });
    }, [quill, ProductData.detail]);


    const loadTemplateProduct = async (id) => {
        try {
            const res = await api.get(`${baseUrl}/master-products/${id}/`);
            const t = res.data;

            // Set text fields
            setProductData(prev => ({
                ...prev,
                category: t.category,
                title: t.title,
                detail: t.detail,
                keywords: t.keywords,
                gender: t.gender || "Unisex",
            }));

            // Convert template images → File objects
            if (t.images && t.images.length > 0) {
                const fileList = [];

                for (const img of t.images) {
                    const imageUrl = img.image;

                    const response = await fetch(imageUrl);
                    const blob = await response.blob();

                    const ext = imageUrl.split(".").pop().split("?")[0];
                    const filename = `template_${Date.now()}.${ext}`;

                    const file = new File([blob], filename, { type: blob.type });

                    fileList.push(file);
                }

                // Save into state
                setProductImgs(fileList);

                // Preview images
                if (imagePreviewRef.current) {
                    const preview = imagePreviewRef.current;
                    preview.innerHTML = "";

                    fileList.forEach(file => {
                        const reader = new FileReader();
                        reader.onload = e => {
                            const imgPreview = document.createElement("img");
                            imgPreview.src = e.target.result;
                            imgPreview.style.width = "70px";
                            imgPreview.style.margin = "5px";
                            preview.appendChild(imgPreview);
                        };
                        reader.readAsDataURL(file);
                    });
                }
            }

            if (quill) {
                quill.root.innerHTML = t.detail;
            }
        } catch (err) {
            console.log("Template load failed:", err);
        }
    };

    function fetchData(baseurl) {
        fetch(baseurl)
            .then((response) => response.json())
            .then((data) => {
                setCategoryData(data.results);
            });
    }

    const inputHandler = (event) => {
        setProductData({
            ...ProductData,
            [event.target.name]: event.target.value
        });
    };

    const multipleFilesHandler = (event) => {
    const files = Array.from(event.target.files);

    if (files.length > 0) {
        // Initialize prevImgsRef.current if it's null
        if (!prevImgsRef.current) {
            prevImgsRef.current = [];
        }

        setProductImgs(prev => [...prev, ...files]);

        const previewContainer = imagePreviewRef.current;
        previewContainer.innerHTML = '';

        // Combine previously stored files with newly added files
        const allFiles = [...prevImgsRef.current, ...files];

        allFiles.forEach(file => {
            const reader = new FileReader();
            reader.onload = (e) => {
                const img = document.createElement('img');
                img.src = e.target.result;
                img.style.width = '70px';
                img.style.margin = '5px';
                previewContainer.appendChild(img);
            };
            reader.readAsDataURL(file);
        });

        // Update the ref so next time it has the previous files
        prevImgsRef.current = allFiles;
    }
};


      

    const addInputFields = () => {
        setInputFields([...inputFields, ["", ""]]);
    };

    const handleInputChange = (index, subIndex, event) => {
        const values = [...inputFields];
        values[index][subIndex] = event.target.value;
        setInputFields(values);
    };

    const removeInputFields = (index) => {
        const values = [...inputFields];
        values.splice(index, 1);
        setInputFields(values);
    };
    const submitHandler = async (event) => {
        setLoading(true);
        event.preventDefault();
        const allFieldsFilled = inputFields.every((pair) => pair[0] && pair[1]);
        
        if (!allFieldsFilled) {
            setLoading(false);
            setErrorMsg("Kindly fill out all required Stock & Variant fields before proceeding. Remove any empty variant rows to continue.");
            return;
        }

        if (!ProductImgs.length) {
            setLoading(false);
            setErrorMsg("Kindly upload at least one product image.");
            return;
        }

        const formData = new FormData();
        formData.append('vendor', VendorId);
        formData.append('category', ProductData.category);
        formData.append('title', ProductData.title);
        formData.append('slug', ProductData.title);
        formData.append('detail', ProductData.detail);
        formData.append('offer_price', ProductData.price);
        formData.append('price', ProductData.price);
        formData.append('usd_price', ProductData.usd_price);
        formData.append('keywords', ProductData.keywords);
        formData.append('gender', ProductData.gender);
        formData.append('visits', 0);
        formData.append('status', 1);
        formData.append('currency', selectedCurrency);

        try {
            const response = await api.post(baseUrl + '/products/', formData, {
                headers: { 'content-type': 'multipart/form-data',Authorization: `Bearer ${token}` }
            });

            if (response.status == 201) {
                const productId = response.data.id;
                
                const postData = inputFields.map(([size, qty]) => ({
                    product: productId,
                    size: size,
                    qty: qty
                }));

                await Promise.all(postData.map(row => axios.post(baseUrl + "/size/", row)));

                if (Array.isArray(ProductImgs)) {
                    await Promise.all(
                        ProductImgs.map(file => {
                            const ImgFormData = new FormData();
                            ImgFormData.append('product', productId);
                            ImgFormData.append('image', file); // always File
                            return axios.post(baseUrl + '/product-imgs/', ImgFormData);
                        })
                    );
                }

                setLoading(false);

                setSuccessMsg('Product Added Successfully');
                setTimeout(() => setSuccessMsg(''), 2500);
                setErrorMsg('');
                setProductImgs([]);
                setProductData({
                    "vendor": '',
                    "category": '',
                    "title": '',
                    "slug": '',
                    "detail": '',
                    "price": '',
                    "offer_price": '',
                    "usd_price": '',
                    "keywords": '',
                    "gender": '',
                    "image": '',
                    "visits": '',
                    "status": '',
                    "currency": '',
                });
                setInputFields([["", ""]]);

                // Clear the contents of the image preview div
                if (imagePreviewRef.current) {
                    imagePreviewRef.current.innerHTML = ''; // Clear contents of image_preview1
                }
                await checkStoreSetupStatus({ navigate, location, setSetupStatus });
            } else {
                setLoading(false);
                setErrorMsg('There was a problem adding the product. Kindly try again.');
                setSuccessMsg('');
            }
        } catch (error) {
            setLoading(false);
            //console.error("Error during product submission:", error);
            setErrorMsg('An error occurred. Kindly try again.');
        }
    };

    const selectedCategory = CategoryData.find(cat => cat.id == ProductData.category)?.title || "default";
    const placeholderMap = {
        "Beauty & Personal Care Products": "50ml, 100ml, 250ml",
        Fragrance: "50ml, 100ml, 250ml",
        Accessories: "Color, Material, Length",
        "Beauty Products": "Shade, ml, Pack size",
        Fashion: "XL, L, M, S",
        "Food & Beverages": "500g, 1kg, 1L",
        "Health & Wellness": "Dose, Bottle size, Pack count",
        Electronics: "Watts, Processor type, Speed",
        default: "XL, ml, kg, Inches, Generic"
    };


    const buttonEnable = ProductImgs.length > 0 && ProductData.category && ProductData.title && ProductData.price;


    return (
        <>
            <Helmet>
                <title>Add Product </title>
                <meta name="description" content={`Manage Stock`} />
            </Helmet>
            <section className="container mtopcon dashb">
                <div className="row">
                <div className="col-12 col-lg-2 dash-min mb-3">
                        <div className="nav-left-sidebar sidebar-dark pc">
                            <div className="slimScrollDiv" ><div className="menu-list" >
                                <nav className="navbar navbar-expand-lg navbar-light nav-l-con">
                                    <a className="d-xl-none d-lg-none" href="#"></a>
                                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                        <span className="navbar-toggler-icon"></span>
                                    </button>
                                    <div className="collapse navbar-collapse" id="navbarNav">
                                        <Sidebar/>
                                    </div>
                                </nav>
                            </div><div className="slimScrollBar"></div><div className="slimScrollRail"></div></div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-10 dash-max">                        
                        <div className="row mb-3 ph-header-con">
                            <div className="col-7 pt-2"><h6 className="pageheader-title mb-3">Add New Product</h6></div>
                            <div className="col-5"><Link to="/seller/products"><button className="btn btn-primary f85 float-right"><ArrowLeft/></button></Link></div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-lg-4">
                                <div className="card shadow-sm border border-secondary border-opacity-10">                               
                                
                                    <div className="card-body">   
                                            <div className="row">
                                                <label className="form-label font9 mb-0">Select atleast 2 Product Images</label>
                                                <div className="upimgcon">
                                                    <input
                                                        type="file"
                                                        name="images[]"
                                                        id="images1"
                                                        multiple
                                                        className="form-control opzero"
                                                        required
                                                        onChange={multipleFilesHandler}
                                                    /> <button className="btn addimg"><Plus/> </button>
                                                </div>
                                                <div className="col-7 p-0 previewimg">
                                                    <div id="image_preview1" ref={imagePreviewRef}>

                                                        
                                                    </div>
                                                </div>
                                            </div>   
                                            
                                            <div className="mb-3">
                                                <label className="form-label font9 mb-0 text-bold">Gender</label>
                                                <select className="form-control addprobginpt" name='gender' onChange={inputHandler} value={ProductData.gender}>
                                                        <option value='Unisex'>Unisex</option>
                                                        <option value='Female'>Female</option>
                                                        <option value='Male'>Male</option>
                                                </select>
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label font9 mb-0 text-bold">Category</label>
                                                <select className="form-control addprobginpt" name='category' onChange={inputHandler} value={ProductData.category}>
                                                <option value="">Select</option>
                                                    {
                                                        CategoryData.map((item,index)=>{ 
                                                            return <option value={item.id} key={index}>{item.title}</option>
                                                        })
                                                    }
                                                </select>
                                            </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-8">
                                <div className="card shadow-sm border border-secondary border-opacity-10">
                                
                                    <div className="card-body mb-4">                        
                                        <form>
                                            <div className="mb-3">
                                                <div className="col-12">
                                                    <label className="form-label font9 mb-0 text-bold">Product Name</label>
                                                    <input type="text" onChange={inputHandler} value={ProductData.title} name="title"  className="form-control addprobginpt" id="fnm"/>
                                                </div>
                                            </div>
                                            <div className="mb-3">
                                                <div className="col-12">
                                                    <label className="form-label font9 mb-0 text-bold">Price</label>
                                                    <input type="number" onChange={inputHandler} value={ProductData.price} name="price" className="form-control addprobginpt" id="lnm"/>
                                                </div>
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label font9 mb-0 text-bold">
                                                    Description <i>(Optional)</i>
                                                </label>
                                                <div
                                                    ref={quillRef}
                                                    className="addprobginpt br-10b border-none addpro-textarea"
                                                    style={{ minHeight: "140px" }}
                                                />
                                            </div>


                                            <div className="mb-3">
                                                <label className="form-label font9 mb-0 text-bold">Stock & Variants</label>
                                                <div className="row mb-0">
                                                    <div className="col-5">
                                                        <label className="form-label font9 mb-0 grey-text">Variant Name</label>
                                                    </div>
                                                    <div className="col-5">
                                                        <label className="form-label font9 mb-0 grey-text">Qty</label>
                                                    </div>
                                                </div>

                                                {inputFields.map((pair, index) => (
                                                    <div key={index} className="row mb-3">
                                                        <div className="col-5">
                                                            <input
                                                                type="text"
                                                                className="form-control addprobginpt w-100 size_mn"
                                                                value={pair[0]}
                                                                onChange={(event) => handleInputChange(index, 0, event)}
                                                                placeholder={placeholderMap[selectedCategory] || placeholderMap.default}
                                                            />
                                                        </div>
                                                        <div className="col-5">
                                                            <input
                                                                type="number"
                                                                className="form-control addprobginpt w-100 qty_mn"
                                                                value={pair[1]}
                                                                onChange={(event) => handleInputChange(index, 1, event)}
                                                                placeholder="1"
                                                            />
                                                        </div>
                                                        <div className="col-2">
                                                            <span onClick={() => removeInputFields(index)} style={{ marginLeft: "5px" }}>
                                                                <X/>
                                                            </span>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                            <div onClick={addInputFields} className="font9 pointer">
                                                + Add Size Variant
                                            </div>
                                            { loading === true ? <><button type="button" className="col-12 btn btn-primary mt-4 big-btn">Loading...</button></> : <><button type="button" disabled={!buttonEnable} onClick={submitHandler} className="col-12 btn btn-primary mt-4 big-btn">Add Product</button></>}
                                            
                                                
                                            {successMsg && <p className="text-success text-center mt-3"><b>{successMsg}</b></p> } 
                                            {errorMsg && <p className="text-danger text-center mt-3"><b>{errorMsg}</b></p> } 
                                            
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AddProduct;